// extracted by mini-css-extract-plugin
export default {"tableHeader":"Clw0Ujw_Tkqu1k62OYYR"};